import { Locale } from "date-fns";
import { es, fr, de, pt, it, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

const dateLocales: Record<string, Locale> = { en: enUS, es, fr, de, pt, it };

export function useDateLocale(): Locale {
  const { i18n } = useTranslation();
  return dateLocales[i18n.language] || enUS;
}
